/**
 * InvoiceInformation Component
 */

import { getCountryLabelFromCode, getStateLabelFromCode } from '../../../../redux/helpers/countries';
import { formatAddress } from '../../../../utils/address';
import { nl2br } from '../../../../utils/react';

import { size } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { kCheckoutNoInputLabel } from '../../../pages/Checkout/config';

interface IOwnStateProps {
  getCountryLabel(countryCode: string): string | undefined;
  getStateLabel(stateCode: string): string | undefined;
}

interface IOwnProps {
  order: GQL.IOrder;
}

type InvoiceInformationProps = IOwnProps & IOwnStateProps;

const classes = new BEM('invoice__information');

class InvoiceInformation extends React.Component<InvoiceInformationProps, any> {
  renderInformation(label: string, value: string | number | null | undefined | JSX.Element[]) {
    return value && (
      <div {...classes('item') }>
        <Span size="medium" textColor="bw6" {...classes('item__title') }>{label}:</Span>
        <Heading is="h5" WrappedComponent="div">{value}</Heading>
      </div>
    );
  }

  renderRepresentativeInformation() {
    const rep = this.props.order!.authorized_representative!;
    const str = `${rep.name}\n${rep.role!.name}\n${rep.email}${rep.phone ? `\n${rep.phone}` : ``}`;
    return this.renderInformation('Authorized Representative', nl2br(str));
  }

  renderAddress(address: GQL.IOrderAddress) {
    const addressString = formatAddress(address, this.props.getCountryLabel, this.props.getStateLabel, true);
    return this.renderInformation('Address', nl2br(addressString));
  }

  render() {
    const {
      order: data,
    } = this.props;
    return (
      <section {...classes()}>
        {!!size(data.licensee_address) && (
          <section {...classes('section', 'license') }>
            <header {...classes('section__header') }>
              <Heading is="h6">Licensee Information</Heading>
            </header>
            {this.renderInformation('Company Name', data.licensee_address!.company)}
            {this.renderInformation('Company Type', data.licensee_address!.company_type!.name)}
            {this.renderAddress(data.licensee_address!)}
            {this.renderRepresentativeInformation()}
          </section>
        )}
        {!!size(data.billing_address) ? (
          <section {...classes('section', 'billing') }>
            <header {...classes('section__header') }>
              <Heading is="h6">Billing Information</Heading>
            </header>
            {this.renderInformation('Company Name', data.billing_address!.company)}
            {this.renderInformation('Company Type', data.billing_address!.company_type!.name)}
            {this.renderAddress(data.billing_address!)}
          </section>
        ) : !!size(data.licensee_address) ? (
          <section {...classes('section', 'billing') }>
            <header {...classes('section__header') }>
              <Heading is="h6">Billing Information</Heading>
            </header>
            {this.renderInformation('Company Name', data.licensee_address!.company)}
            {this.renderInformation('Company Type', data.licensee_address!.company_type!.name)}
            {this.renderAddress(data.licensee_address!)}
          </section>
        ) : null}
        {!!size(data.project_details) && (
          <section {...classes('section', 'project') }>
            <header {...classes('section__header') }>
              <Heading is="h6">Project Details</Heading>
            </header>
            {this.renderInformation('Brand', data.project_details!.brand || kCheckoutNoInputLabel)}
            {this.renderInformation('Project Title', data.project_details!.product || kCheckoutNoInputLabel)}
            {this.renderInformation('Reference', data.project_details!.reference)}
            {this.renderInformation('PO Number', data.project_details!.po_number)}
            {this.renderInformation('Notes', data.project_details!.notes)}
          </section>
        )}
      </section>
    );
  }
}

const ConnectedInvoiceInformation = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  (state) => ({
    getCountryLabel: (countryCode) => getCountryLabelFromCode(countryCode)(state),
    getStateLabel: (stateCode) => getStateLabelFromCode(stateCode)(state),
  }),
)(InvoiceInformation);
export default ConnectedInvoiceInformation;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/Invoice/InvoiceInformation.tsx